import { render, staticRenderFns } from "./PlansDetails.vue?vue&type=template&id=6ea5dd0c&scoped=true"
import script from "./PlansDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlansDetails.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PlansDetails.vue?vue&type=style&index=0&id=6ea5dd0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea5dd0c",
  null
  
)

export default component.exports